import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux';
import { logOut, login, resetPassword } from '../logic/login/action';
import {useLocation, useNavigate} from 'react-router-dom'
import InputComponent from './input';
import FormikForm from './commonForm';
import { feildsLogin, initialValuesLogin, validationSchemaLogin } from '../fromsUtil/login.form';
// import { Link } from '@mui/material';
import {Link} from 'react-router-dom'
import logo from '../images/logo_clock.png'
import { feildsPassword, initialValuesPassword, validationSchemaPassword } from '../fromsUtil/resetPassword';


const ChangePassword = () => {
    const [data, setData] = useState({
        email:"",
        password:'',
        confirmPassword:''
    });

    const route = useLocation();
    const navigate = useNavigate();

    const superadmin = useMemo(()=>{
        const dt = new URLSearchParams(route.search);
        if(dt.get('email')){
            return dt.get('email');
        }else{
            return '';
        }
    },[route.search]);


useEffect(()=>{
    console.log(superadmin,'how many');
    if(superadmin === ''){
        navigate('/admin/verify'+route.search);
    }else if(data.email === ''){
        setData(prev=>({...prev,email:superadmin}));
    }
},[superadmin]);
    

    const dispatch = useDispatch();
    const onSubmit = async(values)=>{
        await resetPassword(dispatch,values.password,data.email,navigate)
    }
  return (
    <div className='w-screen bg-white h-auto flex items-center justify-center flex-col'>
        <div className='bg-secondry/5 w-full'>
      <header className='w-full lg:w-[80%] mx-auto flex items-center py-4 justify-between px-4'>
      <a href="/">
        <img src={logo} className='w-20 h-20'></img>
        </a>
        <div className='flex items-center gap-2'>
        <p className='hidden lg:inline-block'>Need an account?</p>
      <Link to={'/admin/register'} onClick={()=>logOut(dispatch)}>
      <span className='text-secondry border-b border-b-secondry' >Sign Up</span>
      </Link>
        </div>
      </header>
      </div>
      <div className='bg-secondry/5 w-full'>
      <div className='w-full  lg:w-[80%] mx-auto flex justify-center items-start gap-4 min-h-screen'>
          
          <div className='flex-1 min-w-full lg:min-w-[45%] h-full p-4 lg:p-0 relative'>
              <div className='bg-white shadow-2xl shadow-gray-200 rounded-lg w-full lg:w-[40%] mx-auto flex flex-col gap-4 lg:gap-8 p-4 lg:p-16'>
                <h2 className='font-normal text-xl'>Change your password</h2>
               
                <FormikForm
           initialValues={initialValuesPassword}
           fields={feildsPassword}
           validationSchema={validationSchemaPassword}
           action={(disabled)=><button disabled={disabled} className='w-full' type='submit'>Reset Password</button>}
           onSubmit={onSubmit}
        //    extra_element={<Link to={'/admin/verify'}><p className='text-right cursor-pointer'>Forgot password?</p></Link>}
           />
                <div className='w-full text-center'>
                    <p className='text-gray-500 text-center text-xs w-full'>By signing in, you agree to our <span className='text-secondry'>Terms & Conditions</span> & <br/><span className='text-secondry'>Privacy Policy.</span></p>
                {/* <Link to={'/admin/verify'}><p className='highlited'>Forgotten your password?</p></Link> */}
                </div>
                {/* <button></button> */}
              </div>
          </div>
      </div>
      </div>
    </div>
  )
}

export default ChangePassword

{/* <div className='flex-1 bg-primary h-full hidden lg:flex justify-center items-center'>
                <img src="https://taa.dukaani.in/img/dashboard.png" className='w-[60%]' alt="Login image" width={400} height={400} />
        </div>
        <div className='flex-1 h-full overflow-y-scroll lg:overflow-y-hidden'>
        <div className='w-full h-auto min-h-full lg:h-full px-10 lg:px-32 flex flex-col items-start justify-center gap-4'>

                <h1 className='text-4xl font-bold mb-4'>Reset Password</h1>

                <InputComponent
                label={'Enter new password'}
                name={'password'}
                value={data.password}
                onChange={(e)=>setData(prev=>({...prev,password:e.target.value}))}
                isRequired={true}
                message={'Password is required'}
                />
                <InputComponent
                label={'Confrim Password'}
                name={'confirmPassword'}
                value={data.confirmPassword}
                validator={(e)=>e===data.password}
                onChange={(e)=>setData(prev=>({...prev,confirmPassword:e.target.value}))}
                isRequired={true}
                message={'Confirm password should match password'}
                />
                <button className='w-full' onClick={onSubmit}>CHANGE</button>

        
           </div>
        </div> */}